export const getSuppliesEffect = (setData, supplies, user_id, get, dispatch) => () => {
  if (!Object.keys(supplies).lenght) {
    get('/solicitudes/by_usuario/' + user_id, null)
      .then(({ data }) => {
        dispatch(setData(data))
      })
      .catch(() => console.error('Error fetching user supplies'))
  }
}
